import styles from "./user-stats.module.scss";

import default_avatar from "./default_avatar.jpg";

const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };

const UserStats = ({name, avatar, date, birth, missionsComplete, totalValue}) => {
    const avatarImage = avatar || default_avatar;
    const style = {
        backgroundImage: `url(${avatarImage})`,
    };

    const [year, month, day] = date.split("-");
    const fullDate = new Date(year, month - 1, day);

    const formatDate = fullDate.toLocaleString("en-US", dateOptions);

    return (
        <div className={styles.wrapper}>
            <div className={styles.avatar} style={style} />
            <div>
                <h4 className={styles.name}>{name}</h4>
                <p className={styles.info}>Missions accomplished: {missionsComplete}</p>
                <p className={styles.info}>Total value: $ {totalValue}</p>
                {/*<p className={styles.info}>Tons of CO2 saved: 220</p>*/}
                <p className={styles.date}>{formatDate}</p>
            </div>
        </div>
    )
}

export default UserStats;
